export default {
      id: "content-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#content",
      toString: function () {
        return this.url;
      }
    }